<ng-container *w-media-query="{ min: hideBothIfWidthLess() }">
  <ng-container *w-media-query="{ min: hideExpandIfWidthLess() }">
    <button class="btn btn-icon btn-outline" (click)="expandedStore.toggle('expanded')">
      <cds-icon
        shape="angle"
        size="20"
        [title]="'Vollbild' | mrTranslate"
        [direction]="expandedStore.expanded() ? 'right' : 'left'" />
    </button>
  </ng-container>

  <ng-container *w-media-query="{ min: hideSplitIfWidthLess() }">
    <button class="btn btn-icon btn-outline" (click)="expandedStore.toggle('split50')">
      <cds-icon [title]="'Splitscreen' | mrTranslate" size="20" shape="map" [solid]="expandedStore.split50()" />
    </button>
  </ng-container>
</ng-container>
